class NotFoundController {
  /* @ngInject */
  constructor() {
    this.name = 'notFound';
  }
}

export default NotFoundController;
